'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutStack } from 'design-system/client';
import styles from './PlatformForm.module.css';
import { Messages } from '@/components/Messages';
import type { DonationFormProps } from '@/donationForm/types';
import AddressFields from '@/donationPages/_dependencies/components/formParts/AddressFields';
import AddressFieldToggle from '@/donationPages/_dependencies/components/formParts/AddressFieldToggle';
import AmountAndIntervalSelection from '@/donationPages/_dependencies/components/formParts/AmountAndIntervalSelection';
import CodonationBox from '@/donationPages/_dependencies/components/formParts/CodonationBox';
import CompanyFields from '@/donationPages/_dependencies/components/formParts/CompanyFields';
import Debug from '@/donationPages/_dependencies/components/formParts/Debug';
import DonationFormCaptcha from '@/donationPages/_dependencies/components/formParts/DonationFormCaptcha';
import GeneralError from '@/donationPages/_dependencies/components/formParts/GeneralError';
import HeroImage from '@/donationPages/_dependencies/components/formParts/HeroImage';
import HolderFields from '@/donationPages/_dependencies/components/formParts/HolderFields';
import HolderHeadline from '@/donationPages/_dependencies/components/formParts/HolderHeadline';
import HolderTitle from '@/donationPages/_dependencies/components/formParts/HolderTitle';
import MessageField from '@/donationPages/_dependencies/components/formParts/MessageField';
import PaymentMethodError from '@/donationPages/_dependencies/components/formParts/PaymentMethodError';
import PaymentMethodSelection from '@/donationPages/_dependencies/components/formParts/PaymentMethodSelection';
import PlatformNewsletterCheckbox from '@/donationPages/_dependencies/components/formParts/PlatformNewsletterCheckbox';
import ProhibitedNotice from '@/donationPages/_dependencies/components/formParts/ProhibitedNotice';
import StripeCCFields from '@/donationPages/_dependencies/components/formParts/StripeFields/StripeCCFields';
import StripeSEPADebitFields from '@/donationPages/_dependencies/components/formParts/StripeFields/StripeSEPADebitFields';
import SubmitButton from '@/donationPages/_dependencies/components/formParts/SubmitButton';
import Terms from '@/donationPages/_dependencies/components/formParts/Terms';
import TotalDonationAmount from '@/donationPages/_dependencies/components/formParts/TotalDonationAmount';
import TrustLogos from '@/donationPages/_dependencies/components/formParts/TrustLogos';
import VotingQuestion from '@/donationPages/_dependencies/components/formParts/VotingQuestion';
import YoutubeFields from '@/donationPages/_dependencies/components/formParts/YoutubeFields';
import { useDonationFormValues } from '@/donationPages/_dependencies/helpers';
import { useShowPaymentError } from '@/helpers/hooks';
function PlatformForm(t0) {
  const $ = _c(60);
  let children;
  let config;
  let initialFFs;
  let initialFormValues;
  let props;
  if ($[0] !== t0) {
    const {
      config: t1,
      children: t2,
      initialFormValues: t3,
      initialFFs: t4,
      bootstrapData,
      loggingData,
      ...t5
    } = t0;
    config = t1;
    children = t2;
    initialFormValues = t3;
    initialFFs = t4;
    props = t5;
    $[0] = t0;
    $[1] = children;
    $[2] = config;
    $[3] = initialFFs;
    $[4] = initialFormValues;
    $[5] = props;
  } else {
    children = $[1];
    config = $[2];
    initialFFs = $[3];
    initialFormValues = $[4];
    props = $[5];
  }
  const {
    donationsProhibited,
    receiverName,
    receiverProfilePicture,
    receiverUrl,
    showCodonation
  } = config;
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["_company_donation"];
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const [companyDonation] = useDonationFormValues(t1);
  useShowPaymentError();
  if (donationsProhibited) {
    let t2;
    if ($[7] !== receiverName || $[8] !== receiverProfilePicture || $[9] !== receiverUrl) {
      t2 = <HeroImage receiverName={receiverName} receiverProfilePicture={receiverProfilePicture} receiverUrl={receiverUrl} linked={true} />;
      $[7] = receiverName;
      $[8] = receiverProfilePicture;
      $[9] = receiverUrl;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    let t3;
    if ($[11] !== receiverUrl) {
      t3 = <ProhibitedNotice backHref={receiverUrl} />;
      $[11] = receiverUrl;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    let t4;
    if ($[13] !== t2 || $[14] !== t3) {
      t4 = <>{t2}{t3}</>;
      $[13] = t2;
      $[14] = t3;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    return t4;
  }
  let t2;
  if ($[16] !== receiverName || $[17] !== receiverProfilePicture || $[18] !== receiverUrl) {
    t2 = <HeroImage receiverName={receiverName} receiverProfilePicture={receiverProfilePicture} receiverUrl={receiverUrl} linked={true} />;
    $[16] = receiverName;
    $[17] = receiverProfilePicture;
    $[18] = receiverUrl;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Messages />;
    t4 = <GeneralError />;
    t5 = <AmountAndIntervalSelection />;
    t6 = <VotingQuestion />;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t3 = $[20];
    t4 = $[21];
    t5 = $[22];
    t6 = $[23];
  }
  let t7;
  if ($[24] !== showCodonation) {
    t7 = showCodonation && <><CodonationBox /><hr className={styles.border} /><TotalDonationAmount /></>;
    $[24] = showCodonation;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <LayoutStack space="50" className={styles.blockWrapper}><PaymentMethodSelection /><StripeCCFields /><StripeSEPADebitFields /><PaymentMethodError /></LayoutStack>;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t10;
  let t9;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <HolderHeadline />;
    t10 = <HolderFields />;
    $[27] = t10;
    $[28] = t9;
  } else {
    t10 = $[27];
    t9 = $[28];
  }
  let t11;
  if ($[29] !== companyDonation) {
    t11 = !companyDonation && <><MessageField /><YoutubeFields /></>;
    $[29] = companyDonation;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11) {
    t12 = <LayoutStack space="300" className={styles.blockWrapper}>{t9}{t10}{t11}</LayoutStack>;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== companyDonation) {
    t13 = companyDonation && <LayoutStack className={styles.blockWrapper} space="400"><HolderTitle /><LayoutStack space="400"><CompanyFields /><AddressFields required={true} /><MessageField /><YoutubeFields /></LayoutStack></LayoutStack>;
    $[33] = companyDonation;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== companyDonation) {
    t14 = !companyDonation && <LayoutStack className={styles.blockWrapper} space="200"><AddressFieldToggle><AddressFields required={true} /></AddressFieldToggle></LayoutStack>;
    $[35] = companyDonation;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <PlatformNewsletterCheckbox />;
    t16 = <SubmitButton />;
    t17 = <Terms />;
    t18 = <TrustLogos />;
    t19 = <DonationFormCaptcha />;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
  } else {
    t15 = $[37];
    t16 = $[38];
    t17 = $[39];
    t18 = $[40];
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t12 || $[43] !== t13 || $[44] !== t14) {
    t20 = <div className={styles.formFieldsContainer}>{t8}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}</div>;
    $[42] = t12;
    $[43] = t13;
    $[44] = t14;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== children || $[47] !== t20 || $[48] !== t7) {
    t21 = <div className={styles.donationFormContent}>{children}{t3}{t4}{t5}{t6}{t7}{t20}</div>;
    $[46] = children;
    $[47] = t20;
    $[48] = t7;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== props || $[51] !== t21) {
    t22 = <form {...props}>{t21}</form>;
    $[50] = props;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== initialFFs || $[54] !== initialFormValues) {
    t23 = <Debug initialFFs={initialFFs} initialFormValues={initialFormValues} />;
    $[53] = initialFFs;
    $[54] = initialFormValues;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t2 || $[57] !== t22 || $[58] !== t23) {
    t24 = <>{t2}{t22}{t23}</>;
    $[56] = t2;
    $[57] = t22;
    $[58] = t23;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  return t24;
}
export default PlatformForm;